import {
  FileUploadManifest,
  FileUploadRequest,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/upload/s3-file-upload-manifest';
import {
  SampleSheetRequest,
  SampleSheetResponse,
} from '@easy-genomics/shared-lib/src/app/types/easy-genomics/upload/s3-file-upload-sample-sheet';
import { httpClient } from '@/lib/api/client';

class UploadsModule {
  async getSampleSheetCsv(req: SampleSheetRequest): Promise<SampleSheetResponse> {
    const res = await httpClient.call<SampleSheetResponse>('POST', '/upload/create-file-upload-sample-sheet', req);

    if (!res) {
      throw new Error('Failed to create file upload sample sheet');
    }

    return res;
  }

  async getFileUploadManifest(req: FileUploadRequest): Promise<FileUploadManifest> {
    const res = await httpClient.call<FileUploadManifest>('POST', '/upload/create-file-upload-request', req);

    if (!res) {
      throw new Error('Failed to retrieve file upload manifest');
    }

    return res;
  }
}

export default UploadsModule;
